<template>
    <div class="TTL-el-form-search-regular">
    <el-form inline="true">
        <el-form-item>
            <wcselect :option="{placeholder:'请选择提醒类型',width:'170px',clearable:true,filterable:true,ischange:true}"
                :value="param.typeid"
                :list="typelist"
                @finish="(val)=> {
                    param.typeid=val.value;
                    param.ischange=true;
                    param.isshow=true;
                }"
            />
        </el-form-item>
        <el-form-item>
            <wctime 
                :option="{clearable:true,width:'300px',ischange:true}"
                :value="param.time"
                @finish="(val)=> {
                    param.time=val.value;
                    param.ischange=true;
                }"
            />
        </el-form-item>
        <el-form-item>
            <wcinput :option="{placeholder:'请输入事件类型名称',clearable:true,ischange:true,isinput:true,iskeydown:true}" 
                :value="param.key"
                @finish="(val)=> {
                    if(val.type=='input') {param.key=val.value;param.ischange=true;}
                    if(val.type=='change') {param.key=val.value;param.ischange=true;param.isshow=true;}
                    if(val.type=='keydown') GetSheduleInfos();
                }"
            />
        </el-form-item>
        <el-form-item>
            <wcbutton :option="{title:'搜索'}" @finish="GetSheduleInfos()" />
        </el-form-item>
        <el-form-item>
            <wcbutton :option="{title:'添加日程'}" @finish="AddShedule()" />
        </el-form-item>
    </el-form>
    </div>

    <div class="TTL-table top20" id="table-shedule-obj">
        <el-table :data="list" stripe="true" empty-text="" ref="pet" @selection-change="selecttable">
            <template v-slot:empty><el-empty description="暂无数据" /></template>
            <el-table-column type="selection" />
            <el-table-column label="序号" type="index" min-width="50" align="center" />
            <el-table-column label="日程类型" align="center" v-if="pagelabel.notice_thumb">
                <template #default="scope">
                    <div class="TTL-pet-infos">
                    <wcimage :value="scope.row.notice_thumb" :option="{size:'middle'}" />
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="提醒信息" align="center" v-if="pagelabel.notice_typename">
                <template #default="scope">
                    <div class="TTL-pet-name TTL-pet-lab">{{'【'+scope.row.notice_typename+'】'+scope.row.petname}}</div>
                </template>
            </el-table-column>
            <el-table-column label="所属商户" align="center" v-if="pagelabel.shopname">
                <template #default="scope">
                    <div class="TTL-pet-name">{{scope.row.shopname}}</div>
                </template>
            </el-table-column>
            <el-table-column label="备注" align="center" v-if="pagelabel.note">
                <template #default="scope">
                    <div class="TTL-pet-name">{{scope.row.note ? scope.row.note : '/'}}</div>
                </template>
            </el-table-column>

            <el-table-column label="状态" align="center" v-if="pagelabel.status">
                <template #default="scope">
                    <div style="float:left;width:100%;display:inline-flex;width:100%;justify-content:center;align-items:center;">
                    <div>{{scope.row.status==0 ? '进行中' : '已完成'}}</div>
                    <div class="TTL-info-status-image" v-if="scope.row.status==1 && scope.row.finish_status==1">
                        <el-tooltip :content="'推送失败：'+scope.row.finish_msg" placement="top">
                        <el-image :src="scope.row.finish_status==0 ? require('@/assets/icon/msg-notice.png') : require('@/assets/icon/wrong.png') " />
                        </el-tooltip>
                    </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" align="center" v-if="pagelabel.create_day">
                <template #default="scope">{{scope.row.create_day}} {{scope.row.create_time}}</template>
            </el-table-column>
            <el-table-column label="是否已设置提醒时间" align="center" v-if="pagelabel.isremind">
                <template #default="scope">
                    <div>{{scope.row.isremind==1 ? scope.row.remind_day+' '+scope.row.remind_time : '/'}}</div>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right">
                <template #default="scope">
                    <div class="TTL-btn-list">
                    <wcbutton :option="{title:'编辑'}" @finish="EditSchedule(scope.row.id)" v-if="scope.row.status==0" />
                    <wcbutton :option="{title:'删除',type:'del'}" @finish="DelSchedule(scope.row.id)" class="left10" />
                    <wcbutton :option="{title:'标记完成',type:'del'}" @finish="FinishSchedule(scope.row.id)" v-if="scope.row.status==0" class="left10" />
                    </div>
                </template>
            </el-table-column>

        </el-table>
    </div>
    <div class="TTL-page-box top20">
        <div class="TTL-page-box-in">
            <div class="TTL-select TTL-page-left">
                <el-select v-model="handlevalue" placeholder="请选择操作" clearable @change="changehandle">
                    <el-option v-for="(item,index) in handleinfos" :key="index" :label="item.name" :value="item.id" />
                </el-select>
            </div>
            <div class="TTL-page TTL-page-right">
                <wcpage 
                    :row="param.rows" 
                    :p="param.p" 
                    :rollpage="param.rollpage" 
                    @finish="(val)=> {
                        param.p=val.p;
                        param.rollpage=val.rollpage;
                        GetSheduleInfos();
                    }"
                />
            </div>
        </div>
    </div>

    <!-- 页面标签 -->
    <Pagelabel :value="showpagelabel" :type="'PetSchedule'" 
        @finish="(val)=> {
            showpagelabel=false;
            Getpagelabel(true);
        }" 
    />

</template>

<script>
import Pagelabel from '@/views/System/Pagelabel';
import INTERFACE_MODEL_PETS from '@/Interface/Pets/Schedule';
export default {
    components:{
        Pagelabel
    },
    data() {
        return {
            showpagelabel:false,
            pagelabel:{},
            param: {
                id:'',
                typeid:'',
                time:'',
                ischange:false,
                p:1,
                rollpage:10,
                rows:0
            },
            handlevalue:'',
            handleinfos:[
                {id:1,name:'批量删除日程'},
                {id:2,name:'批量修改日程'},
            ],
            list:[],
            typelist:[],
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {

        /** 修改页面显示标签信息 **/
        ChangePageLabel() {
            this.showpagelabel=true;
        },


        /** 页数初始化 **/
        OnloadMethod() {
            this.Getpagelabel();      //获取页面显示标签信息
            this.GetSheduleInfos();   //获取日程信息列表
            this.Gettypelist();       //获取事件类型
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {              //组件已存在，同级兄弟元素调用时产生的操作
                this.GetSheduleInfos();   //获取宠物信息列表
            }else if(data.reload) {       //浏览器重新刷新时执行的操作
                
            }
        },


        /** 批量操作 **/
        changehandle(index) {
            this.handlevalue='';
            this.$confirm.confirm(
                '该操作将会批量修改数据，且不可恢复，是否执行 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(()=> {

               var ids=this.GetSelectDataIds();
               if(ids.length == 0) {this.$notice({title:'消息提示',message:'请选择要批量执行的宠物',type:'warning'});return false;}
               if(index==1) { //批量删除宠物
                   this.DelScheduleInfos(ids.join(',')); 

               }else if(index==2) { //批量修改宠物类型
                   this.GoEditShedule(ids.join(','));
               }

            }).catch(()=> {
                
            });
        },


        /** 编辑提醒信息 **/
        EditSchedule(id) {
            this.GoEditShedule(id);
        },


        /** 删除提醒 **/
        DelSchedule(id) {
            this.DelScheduleInfos(id);
        },


        /** 标记完成提醒 **/
        FinishSchedule(id) {
            INTERFACE_MODEL_PETS.FINISH_SCHEDULE({id:id}).then((res) => {
                 if(res.status > 0) return false;
                 this.GetSheduleInfos();
            });
        },


        //删除宠物信息
        DelScheduleInfos(ids) {
            INTERFACE_MODEL_PETS.DEL_SCHEDULE({ids:ids}).then((res) => {
                 if(res.status > 0) return false;
                 this.GetSheduleInfos();
            });
        },


        ///////////////////////////////////////
        ///////////////////////////////////////
        //加载宠物信息列表

        /** 获取事件类型 **/
        Gettypelist() {
            INTERFACE_MODEL_PETS.GET_SCHEDULE_CHILD_TYPE_LIST().then((res) => {
                 if(res.status > 0) return false;
                 this.typelist=res.data;
                 console.log(this.typelist);
            });
        },


        /** 获取宠物信息列表 **/
        GetSheduleInfos() {
            if(this.param.ischange) {
                this.param.p=1;
                this.param.ischange=false;
            }

            //loading等待动画加载
            var obj=document.getElementById("table-shedule-obj");
            this.$loading.openloading(obj);
            INTERFACE_MODEL_PETS.GET_PET_SCHEDULE_LIST(this.param).then((res) => {
                 if(res.status > 0) return false;
                 this.$loading.closeloading(obj);
                 this.param.rows=res.data.count;
                 this.list=res.data.list;
            });
        },


        /** 表格数据选择 **/
        selecttable(val) {
            for(var i=0;i < this.list.length;i++) this.list[i].isshow=false;
            for(var i=0;i < val.length;i++) val[i].isshow=true;
            console.log(this.list);
        },


        /** 获取被勾选中的列表数据 **/
        GetSelectDataIds() {
            var ids=[];
            ids=this.list.map((obj)=> obj.isshow ? obj.id : '');
            ids=ids.filter(element=> element!==null && element!==''); //数据进行去除空值处理
            return ids ? ids : [];
        },


         /** 添加宠物信息 **/
        AddShedule() {
            var navinfo={name:'新增日程',labelentry:'AddPetSchedule',components:'AddPetSchedule',isshow:false};
            var data={Method:''};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 编辑宠物信息 **/
        GoEditShedule(ids) {
            var navinfo={name:'编辑日程',labelentry:'EditPetSchedule',components:'EditPetSchedule',isshow:false};
            var data={Method:'',ids:ids};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 获取列表显示 **/
        Getpagelabel(isfresh=false) {
            this.$method.GET_PAGE_LABEL_SETTING('PetSchedule',isfresh).then((res) => {
                this.pagelabel=res ? res : {};
            });
        },


        //加载宠物信息列表
        ///////////////////////////////////////
        ///////////////////////////////////////


    },
}
</script>
<style scoped>
.TTL-select-infos {display:inline-flex;align-items: center;}
.TTL-select-infos span {margin-left:10px;}
.TTL-pet-image {position: relative;display: inline-block;width:60px;height: 60px;}
.TTL-notice-typename {position:absolute;right:0;top:0;margin-right:-15px;background-color: #ffffff;border-radius: 15px;padding:2px 5px;font-size:12px;line-height: 18px;color:#352c07;letter-spacing: 1px;border:1px solid #666eeb;}
.TTL-image-box-sex {width:20px;height: 20px;position:absolute;right:0;top:0;margin-right:-5px;margin-top:-5px;border-radius: 50%;background:#ffffff;}
.TTL-pet-infos {display: flex;align-items: center;}
.TTL-pet-infos-content {display:inline-block;width:calc(100% - 80px);margin-left:25px;}
.TTL-pet-infos-content-info {display: inline-flex;align-items: center;width:100%;}
.TTL-pet-infos-content-item {display:inline-block;color:#666666;background-color: #DCDFE6;padding:7px 15px 5px 15px;font-size:12px;line-height:12px;border-radius: 20px;margin:0 10px 5px 0;zoom:.9;}
.TTL-image-box-small {border-radius: 50%;}
.TTL-notice-note {overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
.TTL-status-load {text-indent:5px;color:#666666;}
.TTL-status-finish {text-indent:5px;color:#666666;}
.TTL-info-status-image {width:23px;height:23px;margin-left:5px;display:inline-flex;justify-content: center;align-items: center;}
.TTL-info-status-image .el-image {display:inline-flex;justify-content: center;align-items: center;width:100%;height:100%;}
.TTL-info-status-image .el-image img {width:100%;height: 100%;}
.TTL-tooltip-note {max-width:200px;line-height: 23px;}
.TTL-pet-infos-name {display:inline-block;width:100%;font-weight: 550;letter-spacing: 1px;}
.TTL-pet-infos-note {display:inline-block;width:100%;font-size:12px;letter-spacing: 1px;color:#999999;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}

.TTL-pet-infos {display:inline-flex;align-items: center;}
.TTL-pet-content {display:inline-block;width:calc(100% - 70px - 10px);margin-left:10px;font-size:0;position:relative;}
.TTL-pet-name {display:inline-block;width:100%;font-size:13px;line-height: 23px;}
.TTL-pet-pettype {display:inline-block;width:100%;font-size:12px;line-height: 18px;color:#999999;letter-spacing: 1px;float:left;margin-left:5px;display: -webkit-box;overflow: hidden;-webkit-box-orient: vertical;-webkit-line-clamp: 2;text-overflow: ellipsis;}
.TTL-pet-labellist {display:inline-block;width:100%;}
.TTL-pet-labels {display:inline-block;padding:5px 10px;font-size:12px;line-height:12px;letter-spacing: 1px;color:#999999;background-color: #EBEDF0;border-radius: 15px;margin-right:10px;zoom:.9}
.TTL-btn-list {display:inline-flex;}
.TTL-pet-lab {color:#666eeb}
</style>